import React from 'react';

/**
 * FullPageLoader
 * Shown during app init / auth check.
 * - Animated teal progress bar at top
 * - Pulsing Vital logo
 * - "Cargando..." with dot-dot-dot animation
 */
const FullPageLoader = () => {
  return (
    <>
      {/* Teal progress bar */}
      <div className="vital-progress-bar" role="progressbar" aria-label="Cargando aplicación" />

      {/* Centered content */}
      <div className="vital-fullpage-loader">
        {/* Logo with pulse glow */}
        <div className="vital-logo-pulse">
          <img
            src="/assets/images/vitaleditado-1772764451846.png"
            alt="Vital Gestión en Salud"
            style={{ width: '160px', height: 'auto', objectFit: 'contain' }}
          />
        </div>

        {/* Cargando text with dots */}
        <p className="loader-text">
          Cargando
          <span className="loading-dots" aria-hidden="true">
            <span>.</span>
            <span>.</span>
            <span>.</span>
          </span>
        </p>
      </div>
    </>
  );
};

export default FullPageLoader;
